module.exports = __webpack_public_path__ + "static/media/ux_table.98027ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Ideation/img/ux_table.png
// module id = 135
// module chunks = 0